import React, { Component } from 'react'
import moment from 'moment'

import { envConstants } from '../../constants'

class HoleHistory extends Component {
  render () {
    const h = this.props.history
    return (
      <div>
        <ul className="ul-hole-history">
          {
            h.map((h, index) => {
              return (
                <li key={index}>
                  <ul className="h-line">
                    <li className="date">{moment.unix(h.eventDate).format(envConstants.momentFormat)}</li>
                    <li className="email">{h.email}</li>
                    <li className="message">{h.message}</li>
                  </ul>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }
}

export default HoleHistory
